// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"fcab3113","726":"63e59fed"}[chunkId] + ".chunk.js";
};